<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <wf-consumer-record-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></wf-consumer-record-form>
  </j-modal>
</template>

<script>

  import WfConsumerRecordForm from './WfConsumerRecordForm'
  export default {
    name: 'WfConsumerRecordModal',
    components: {
      WfConsumerRecordForm
    },
    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (model) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add(model);
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';

  /deep/ .ant-modal-body {
    padding: 6px;
    max-height: none !important;
  }

  /deep/ .ant-form-item {
    margin-bottom: 3px;
  }
</style>